var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patrolLine",attrs:{"onselectstart":"return false;"}},[_c('div',{staticClass:"box"},[_vm._v("中联燃气业务数据看板")]),_c('left',{ref:"left"}),_c('right',{ref:"right"}),_c('div',{ref:"mapRightRef",staticClass:"mapRight",attrs:{"id":"mapRightId"}},[_c('subMap',{ref:"subMap",attrs:{"modeal":'1'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }